import { Col, Form, InputNumber } from 'antd'
import withSort from '../elements/HOC/withSort'
import CustomSelect from '../elements/Select/CustomSelect'
import TaxTypeSelect from '../elements/Select/Lines/TaxType'
import withSelectFetch from '../elements/Select/withSelectFetch'
import { get, round } from 'lodash'
import { defaultFormItemLayout, rules } from '../modules/FormItems'
import React, { Fragment } from 'react'
import { compose } from 'recompose'
import withSpinning from './HOC/withSpinning'

function Taxes(props) {
  const {
    getFieldDecorator,
    getFieldValue,
    setFieldsValue,
    resetFields,
    doc,
    type,
    referer,
    price,
    rateCurrency,
    hideRate,
  } = props

  const taxType = getFieldValue('taxType') || get(doc, 'taxType') || 'ex-tax'
  const isQuoteLine = type === 'quoteLine'

  // useEffect(() => {
  //   if (taxType === 'ex-tax') {
  //     doc.percentage = undefined
  //     doc.rate = undefined
  //   }
  // }, [taxType])

  return (
    <Fragment>
      {!isQuoteLine && (
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Taxable'}>
            {getFieldDecorator('taxType', {
              initialValue: get(doc, 'taxType') || 'ex-tax',
              rules: [{ required: true, message: 'Please Select a Tax Type!' }],
            })(<TaxableSelect placeholder={'Tax Type'} />)}
          </Form.Item>
        </Col>
      )}
      {taxType !== 'ex-tax' && (
        <Fragment>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Tax Type'}>
              {getFieldDecorator('tax.type', {
                initialValue: get(doc, 'tax.type') || get(referer,'tax.type'),
                rules: rules.select,
              })(<TaxTypeSelect />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Tax Percentage'}>
              {getFieldDecorator('tax.percentage', {
                initialValue: get(doc, 'tax.percentage') || get(referer,'tax.percentage'),
                rules: ['CUS', 'STD'].includes(getFieldValue('tax.type')) ? rules.moreThanZero : rules.equalToZero,
              })(
                <InputNumber
                  addonAfter={<span>%</span>}
                  onChange={(e) => setFieldsValue({ 'tax.rate': round((e * price) / 100, 2) })}
                  style={{ width: '100%' }}
                  placeholder={'Tax Percentage'}
                />
              )}
            </Form.Item>
          </Col>
          {!hideRate && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Tax Rate'}>
                {getFieldDecorator('tax.rate', {
                  initialValue:
                    get(doc, 'tax.rate') || round((parseFloat(getFieldValue('tax.percentage')) / 100) * price, 2) || 0,
                  rules: rules.select,
                })(
                  <InputNumber
                    addonBefore={<span>{rateCurrency}</span>}
                    style={{ width: '100%' }}
                    onChange={(e) =>
                      setFieldsValue({
                        'tax.percentage': round((e / price) * 100, 2),
                      })
                    }
                    placeholder={'Tax Rate'}
                  />
                )}
              </Form.Item>
            </Col>
          )}
        </Fragment>
      )}
    </Fragment>
  )
}

const TaxableSelect = compose(
  withSelectFetch({
    dropdown: 'quotes',
    name: 'taxType',
  }),
  withSpinning,
  withSort
)(CustomSelect)

export default Taxes
